const zaercard = {
  getlist: 'zaercard/getlist',
  update: 'zaercard/update',
  remove: 'zaercard/remove',
}
export default zaercard
